import React, { Component } from "react";

class MapElement extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.textRef = React.createRef();
  }

  lightenAnimation(e) {
    this.ref.current.style.opacity = "0.0";
    this.textRef.current.style.marginTop = "10px";
  }

  darkenAnimation(e) {
    this.ref.current.style.opacity = "0.7";
    this.textRef.current.style.marginTop = "90px";
  }

  render() {
    return (
      <div style={wrapperStyle}>
        <div
          style={mapElementStyle}
          onMouseEnter={this.lightenAnimation.bind(this)}
          onMouseLeave={this.darkenAnimation.bind(this)}
        >
          <div style={textCoverStyle} ref={this.textRef}>
            <p style={textStyle}>{this.props.alt}</p>
          </div>
          <div style={coverStyle} ref={this.ref}></div>
          <img
            src={this.props.img}
            alt={this.props.alt}
            style={this.props.alt === "Books" ? altImageStyle : imageStyle}
          />
        </div>
      </div>
    );
  }
}

const wrapperStyle = {
  position: "static",
};

const mapElementStyle = {
  height: "240px",
  width: "240px",
  borderRadius: "5px",
  background: "#bbb",
  color: "#000",
  overflow: "hidden",
  position: "static",
};

const coverStyle = {
  height: "240px",
  width: "240px",
  borderRadius: "5px",
  zIndex: "900",
  position: "absolute",
  backgroundColor: "#ccc",
  transition: "opacity .4s",
  opacity: "0.7",
  cursor: "pointer",
};

const imageStyle = {
  maxHeight: "240px",
  borderRadius: "5px",
  objectFit: "cover",
};

const altImageStyle = {
  maxWidth: "320px",
  borderRadius: "5px",
  objectFit: "cover",
  position: "relative",
  bottom: "220px",
  right: "40px",
};

const textCoverStyle = {
  position: "absolute",
  zIndex: "1000",
  width: "240px",
  height: "50px",
  marginTop: "90px",
  textAlign: "center",
  transition: "all .3s",
};

const textStyle = {
  fontFamily: "Lora, serif",
  fontWeight: "400",
  fontSize: "30px",
  cursor: "pointer",
  transition: "opacity .3s",
};

export default MapElement;
